import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import "./FreightModal.css";

const SentRequestView = ({ show, handleClose, data }) => {
  useEffect(() => {
    AOS.init({ duration: 600, once: true });
  }, []);

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp * 1000);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatLabel = (key) => {
    return key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };

  const formatValue = (key, value) => {
    if (value === null || value === undefined) return "";

    // Some API fields come as "id:label" (e.g. "101:India"). Show only label.
    if (typeof value === "string") {
      const m = value.match(/^\s*\d+\s*:\s*(.+)\s*$/);
      if (m?.[1]) return m[1];
      return value;
    }

    if (key === "requsted_date" || key === "updated_at") return formatDate(value);
    return String(value);
  };

  const excludedKeys = [
    "created_at",
    "request_sender_id",
    "request_receiver_id",
  ];
  const priorityFirst = ["sender_company_name"];
  const priorityLast = ["comment"];

  const getSortedEntries = (dataObj) => {
    const entries = Object.entries(dataObj).filter(
      ([key, value]) =>
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !excludedKeys.includes(key)
    );

    const first = entries.filter(([key]) => priorityFirst.includes(key));
    const last = entries.filter(([key]) => priorityLast.includes(key));
    const middle = entries.filter(
      ([key]) => !priorityFirst.includes(key) && !priorityLast.includes(key)
    );

    return [...first, ...middle, ...last];
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      scrollable
      contentClassName="fr-modal-panel"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bx bx-detail"></i>
          Request Overview
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="fr-mo-inner">
          <div className="row g-3">
            {data &&
              getSortedEntries(data).map(([key, value], index) => {
                const displayValue = formatValue(key, value);

                const isFullWidth = key === "comment";
                const columnClass = isFullWidth ? "col-12" : "col-md-6";

                return (
                  <div
                    key={key}
                    className={columnClass}
                    data-aos="fade-up"
                    data-aos-delay={index * 50}
                  >
                    <div className="fr-mo-field h-100">
                      <div className="fr-mo-label">{formatLabel(key)}</div>
                      <div className="fr-mo-value">{displayValue}</div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SentRequestView;
